import React from 'react';
import { Typography, Button, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '@emotion/react';
import { Add, Create } from '@mui/icons-material';
import Cookies from 'js-cookie';
import placeHolderImage from "assets/no_data_images/no_data_rounds.svg"
import { useSelector } from 'react-redux';
import { hasPermission } from 'utils/index';
import { Primary } from 'ui-components/Buttons';

const NoRounds = ({ placeHolderSx = {} }) => {
    const navigate = useNavigate();
    const theme = useTheme()
    const userPermissions = useSelector((state) => state?.permissions?.userPermissions);
    return (
        <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            minHeight="calc(100% - 164px)"
            textAlign="center"
            padding={3}
        >
            {<img
                src={placeHolderImage} // Replace with your image path
                // alt="No Data"
                style={{ width: '200px', height: 200, marginBottom: '20px', background: '', borderRadius: 8, ...placeHolderSx }} // Adjust the size as needed
            />}
            <Typography variant="title" gutterBottom>
                Ready to Raise Funds?
            </Typography>
            <Typography variant="body1" marginBottom={2} gutterBottom>
                Start by creating your first funding round and invite investors.
            </Typography>
            {hasPermission("startups_new", "edit", userPermissions) && <Primary onClick={() => {
                Cookies.remove("round_id");
                navigate("/startups/rounds/add-round")
            }} sx={{ padding: '10px 16px', fontWeight: 600 }}
            // startIcon={<Create fontSize='1.25rem' />}
            >
                Create a New Round
            </Primary>}
        </Box>
    );
};

export default NoRounds;
